var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-blk"},[_c('span',{staticClass:"head"},[_c('span',{staticClass:"ja",domProps:{"innerHTML":_vm._s(_vm.ja)}}),_c('span',{staticClass:"en"},[_vm._v(_vm._s(_vm.en))])])])}
var staticRenderFns = []

export { render, staticRenderFns }